<template>
   <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      :title="mainTitle"
    >
      <slot name="body">
          
    <div class="">
      <validation-observer ref="moneyTransfer">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <form-mask
                label="قيمة المبلغ المُراد تحويله"
                id="number"
                v-model="form.amount"
                :raw="false"
                placeholder="10,000"
                options="number"
                rules="required"
              />
              
            </b-col>
            <b-col cols="12">

              <form-textarea
                class="my-1"
                label="سبب التحويل"
                rules="required"
                v-model="form.reason"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                label="رقم محضر الجلسة الإدارية التي تمّ خلالها اتخاذ القرار بتسديد الالتزام"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                id="gov"
                ep="v2/selects/meeting-minutes"
                ref="gov"
                rules="required"
              />
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
              
            </b-col>

            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="file"
                accept=".doc,.pdf,.docx"
                v-model="form.file"
                label="كتاب خطي يوضح قيمة المبلغ المُراد تحويله و سبب التحويل"
                rules="required"
              />
            </b-col>

          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
      </slot>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import { required, integer } from "@validations";
import { ValidationProvider } from "vee-validate";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import FormMask from "@/components/form-mask";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormFileInput ,
    FormCurrency ,
    FormMask
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بياناتت المعاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.moneyTransfer.validate().then(async (success) => {
        if (success) {
          
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
